import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, useContext } from "react";
import UserContext from "../context/UserContext.js";
import { isFeatureAllowed } from "../utils/FeatureAccess.js";
import withFeatureRestriction from "../utils/withFeatureRestriction.js";
const HealthFormBuilder = lazy(() =>
  import("../screens/AdminRole/HealthFormBuilder.js")
);
// ONLY ADMIN
const AdminAppointments = lazy(() => import("../screens/Appointments.js"));
const Patients = lazy(() => import("../screens/AdminRole/Patients"));
const AdminStaff = lazy(() => import("../screens/AdminRole/Staff.js"));
const AdminProducts = lazy(() => import("../screens/AdminRole/Products.js"));
const AdminDashboard = lazy(() => import("../screens/AdminRole/Dashboard"));

// COMMON WITH OTHER ROLES
const Invoices = lazy(() => import("../screens//Invoices/Invoices"));
const CreateInvoice = lazy(() => import("../screens/Invoices/CreateInvoice"));
const CreatePreventiv = lazy(() =>
  import("../screens/Invoices/CreatePreventiv")
);
const EditInvoice = lazy(() => import("../screens/Invoices/EditInvoice"));
const PreviewInvoice = lazy(() => import("../screens/Invoices/PreviewInvoice"));
const Services = lazy(() => import("../screens/Services"));
const Settings = lazy(() => import("../screens/Settings"));
const Payments = lazy(() => import("../screens/Payments/Payments.js"));
const EditPayment = lazy(() => import("../screens/Payments/EditPayment"));
const PreviewPayment = lazy(() => import("../screens/Payments/PreviewPayment"));
const CreatePatient = lazy(() => import("../screens/Patients/CreatePatient"));
const Doctors = lazy(() => import("../screens/Doctors/Doctors"));
const DoctorProfile = lazy(() => import("../screens/Doctors/DoctorProfile"));
const ReceptionProfile = lazy(() =>
  import("../screens/Reception/ReceptionProfile")
);
const Receptions = lazy(() => import("../screens/Receptions"));
const Schedule = lazy(() => import("../screens/Schedule.js"));
const NewMedicalRecord = lazy(() => import("../screens/NewMedicalRecord.js"));
const PatientProfile = lazy(() => import("../screens/Patients/PatientProfile"));
const ReportsPage = lazy(() => import("../screens/ReportsPage"));
const Suppliers = lazy(() => import("../screens/Suppliers.js"));

// WITH FEATURE
const WithFeatureSchedule = withFeatureRestriction(Schedule, "schedule");
const WithFeatureInvoices = withFeatureRestriction(Invoices, "invoices");
const WithFeatureCreateInvoice = withFeatureRestriction(
  CreateInvoice,
  "invoices"
);
const WithFeatureCreatePreventiv = withFeatureRestriction(
  CreatePreventiv,
  "invoices"
);
const WithFeatureEditInvoice = withFeatureRestriction(EditInvoice, "invoices");
const WithFeaturePreviewInvoice = withFeatureRestriction(
  PreviewInvoice,
  "invoices"
);
const WithFeaturePayments = withFeatureRestriction(Payments, "payments");
const WithFeatureEditPayment = withFeatureRestriction(EditPayment, "payments");
const WithFeaturePreviewPayment = withFeatureRestriction(
  PreviewPayment,
  "payments"
);
const WithFeatureProducts = withFeatureRestriction(AdminProducts, "products");
const WithFeatureHealthForm = withFeatureRestriction(
  HealthFormBuilder,
  "healthForms"
);
const WithFeatureReportsPage = withFeatureRestriction(ReportsPage, "reports");
const WithFeatureSuppliers = withFeatureRestriction(Suppliers, "suppliers");

export default function AdminRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AdminDashboard />} />
      <Route path="patients" element={<Patients />} />
      <Route path="patients/create" element={<CreatePatient />} />
      <Route path="patients/visiting/:id" element={<NewMedicalRecord />} />
      <Route path="doctors" element={<Doctors />} />
      <Route path="patients/:id" element={<PatientProfile />} />
      <Route path="appointments" element={<AdminAppointments />} />
      <Route path="receptions" element={<Receptions />} />
      <Route path="staff" element={<AdminStaff />} />
      <Route path="staff/doctors/:id" element={<DoctorProfile />} />
      <Route path="staff/reception/:id" element={<ReceptionProfile />} />
      <Route path="services" element={<Services />} />
      <Route path="settings" element={<Settings />} />

      {/* PACKAGE BASED */}
      {/* <Route path="schedule" element={<WithFeatureSchedule />} /> */}
      <Route path="payments" element={<WithFeaturePayments />} />
      <Route path="payments/edit/:id" element={<WithFeatureEditPayment />} />
      <Route
        path="payments/preview/:id"
        element={<WithFeaturePreviewPayment />}
      />
      <Route path="invoices" element={<WithFeatureInvoices />} />
      <Route path="invoices/create" element={<WithFeatureCreateInvoice />} />
      <Route
        path="invoices/preventiv/create"
        element={<WithFeatureCreatePreventiv />}
      />
      <Route path="invoices/edit/:id" element={<WithFeatureEditInvoice />} />
      <Route
        path="invoices/preview/:id"
        element={<WithFeaturePreviewInvoice />}
      />
      <Route path="products" element={<WithFeatureProducts />} />
      <Route path="healthformbuilder" element={<WithFeatureHealthForm />} />
      <Route path="reports" element={<WithFeatureReportsPage />} />
      <Route path="suppliers" element={<WithFeatureSuppliers />} />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
